import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';

interface AutoCreateBaseCompoundChipProps {
  entityName?: string;
  size?: ChipSize;
}

export default function AutoCreateBaseCompoundChip({
  entityName,
  size = ChipSize.SMALL,
}: AutoCreateBaseCompoundChipProps): JSX.Element {
  const text = entityName ? `Base Compound of ${entityName}` : 'New Base Compound';
  return (
    <span {...getTestProps({component: 'AutoCreateBaseCompoundChip', element: 'root'})}>
      <Chip
        icon="question"
        isReadonly={true}
        size={size}
        text={text}
        tooltipTitle="A base compound will be auto-created on submit"
      />
    </span>
  );
}
